import React from 'react';

const ChatListSkeleton: React.FC = () => {
  return (
    <div className="h-full flex flex-col bg-kind-background">
      {/* Header Skeleton */}
      <div className="p-6 border-b border-white/10">
        <div className="h-8 bg-kind-container/50 rounded-lg w-32 mb-6 animate-pulse"></div>

        {/* Search Bar Skeleton */}
        <div className="relative">
          <div className="h-12 bg-kind-container/50 rounded-xl animate-pulse"></div>
        </div>
      </div>

      {/* Chat List Skeleton */}
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="flex items-center p-4 rounded-xl bg-kind-container/30 animate-pulse"
          >
            {/* Avatar Skeleton */}
            <div className="flex-shrink-0 mr-4">
              <div className="w-12 h-12 rounded-full bg-white/20"></div>
            </div>

            {/* Content Skeleton */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-2">
                <div className="h-4 bg-white/20 rounded w-24"></div>
                <div className="h-3 bg-white/20 rounded w-16"></div>
              </div>
              <div className="h-3 bg-white/20 rounded w-3/4"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatListSkeleton;
